import { render, staticRenderFns } from "./AboveHead.vue?vue&type=template&id=3a40840a&scoped=true&"
import script from "./AboveHead.vue?vue&type=script&lang=js&"
export * from "./AboveHead.vue?vue&type=script&lang=js&"
import style0 from "./AboveHead.vue?vue&type=style&index=0&id=3a40840a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40840a",
  null
  
)

export default component.exports